<form [formGroup]="newSiteForm" fcFormUnloadWarning>
  <div class="form-step-container">
    <div class="form-step-title">Start your carbon site</div>
    <div class="input-label">Contact Information</div>
    <div class="w-100-1">
      <div class="form-inner-fields">
        <mat-form-field class="w-50-2">
          <mat-label>First Name</mat-label>
          <input formControlName="firstName" id="firstName" matInput required type="text" />
        </mat-form-field>
        <mat-form-field class="w-50-2">
          <mat-label>Last Name</mat-label>
          <input formControlName="lastName" id="lastName" matInput required type="text" />
        </mat-form-field>
        <mat-form-field class="w-100-1">
          <mat-label>Email</mat-label>
          <input formControlName="email" id="email" matInput required type="text">
          <mat-error>{{ emailError }}</mat-error>
        </mat-form-field>
        <mat-form-field class="w-50-2">
          <mat-label>Phone</mat-label>
          <input formControlName="phone" id="phone" matInput required type="text" (blur)="formatPhone($event)" />
          @if (phoneNumberError) {
            <mat-error>
              This phone number is invalid.
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="input-label">Property Information</div>

    <mat-form-field class="full-width">
      <mat-label>Forested Acreage</mat-label>
      <input formControlName="acres" id="acres" (blur)="updateAcres()" matInput required type="number" />

      @if (showAcreageWarning) {
        <mat-hint>Only area between 40 and 5000 acres is eligible for a LandYield carbon program. You may continue
          and create an account regardless to explore our offerings.
        </mat-hint>
      }
    </mat-form-field>


    <mat-form-field class="full-width">
      <mat-label>Location</mat-label>
      <input
        matInput
        type="text"
        placeholder="Type county name..."
        aria-label="county"
        [matAutocomplete]="auto"
        data-cy="county-autocomplete-input"
        formControlName="county" />

      @if (county.valid && county.value && !county.value.available) {
        <mat-hint>LandYield is not currently offered in this county. You may continue
          and create an account regardless to explore our offerings.
        </mat-hint>
      }
    </mat-form-field>
    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displayFn">
      <mat-option *ngIf="isLoading" class="is-loading">Loading...</mat-option>
      <ng-container *ngIf="filteredCounties?.length === 0">
        <mat-option [disabled]="true" class="is-loading">County not found</mat-option>
      </ng-container>
      <ng-container *ngIf="!isLoading">
        <mat-option *ngFor="let item of filteredCounties" [value]="item" data-cy="county-autocomplete-option">
          <span>{{ item.county }} - {{ item.state }}</span>
        </mat-option>
      </ng-container>
    </mat-autocomplete>
    <div class="validation-error-on-blue" *ngIf="county.invalid && (county.dirty || county.touched)">
      <div *ngIf="county.errors">Please select a county from the dropdown list.</div>
    </div>
    <input formControlName="hiddenCheck" class="hidden-check" autocomplete="current-password" />

    <div class="step-button-container">
      <button
        (click)="checkAcreageAndProceed()"
        [disabled]="!newSiteForm.valid"
        color="primary"
        data-cy="next-button"
        mat-raised-button
        type="button">
        Create Account
      </button>
    </div>
  </div>
</form>
